import { IconAngleDown, IconAngleUp } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import styles from './Stepper.module.css';

type TProps = {
  index: number;
  minIndex: number;
  maxIndex: number;
  disabled?: boolean;
  onChange: (index: number) => void;
};

export const Stepper = ({
  index,
  disabled,
  minIndex,
  maxIndex,
  onChange,
}: TProps) => {
  const increaseStepper = () => {
    if (index < maxIndex) {
      onChange(index + 1);
    }
  };

  const decreaseStepper = () => {
    if (index > minIndex) {
      onChange(index - 1);
    }
  };

  return (
    <div className={styles.stepper}>
      <Button
        variant="tertiary"
        type="button"
        data-testid="increase-stepper-button"
        className={styles.button}
        onClick={increaseStepper}
        disabled={index >= maxIndex || disabled}
      >
        <IconAngleUp />
      </Button>
      <Button
        variant="tertiary"
        type="button"
        data-testid="decrease-stepper-button"
        className={styles.button}
        onClick={decreaseStepper}
        disabled={index <= minIndex || disabled}
      >
        <IconAngleDown />
      </Button>
    </div>
  );
};
